import type { EmbarcacaoTanquesField } from "@/modules/embarcacoes";
import { formatDetailDate } from "../../../detail-format/detail-format";
import type { DetailFieldDefinition } from "../../../detail-format/detail-fields";

export const TANQUES_ID = "tanques";
export const TANQUES_TITLE = "Tanques";
export const TANQUES_TEST_ID = "embarcacao-tanques";
export const TANQUES_LOADING_MESSAGE = "Carregando os Tanques da embarcação...";

/** Padrão global de estado vazio do Hub para a seção sem informações. */
export const TANQUES_EMPTY_STATE = {
  title: "Nenhuma informação de Tanques disponível",
  description:
    "Assim que houver capacidades de tanques para esta embarcação, elas aparecerão nesta seção.",
};

/**
 * Os 10 campos da seção, na ordem do AC2 — as 8 capacidades em m³, os
 * comentários e a data de atualização da capacidade. O grid os distribui em
 * duas colunas, preenchendo a linha da esquerda para a direita; nenhum campo
 * precisa abrir linha nesta seção.
 */
export const TANQUES_FIELDS: readonly DetailFieldDefinition<EmbarcacaoTanquesField>[] = [
  { key: "capacidadeTotalCombustivel", label: "Capacidade Total de Combustível (m³)" },
  { key: "capacidadeTotalAgua", label: "Capacidade Total de Água (m³)" },
  { key: "capacidadeTotalOro", label: "Capacidade Total de ORO (m³)" },
  { key: "capacidadeTotalAguaLastro", label: "Capacidade Total de Água de Lastro (m³)" },
  { key: "capacidadeTotalOleoBase", label: "Capacidade Total de Óleo de base (m³)" },
  { key: "capacidadeTotalSalmoura", label: "Capacidade Total de Salmoura (m³)" },
  { key: "capacidadeTotalLama", label: "Capacidade Total de Lama (m³)" },
  { key: "capacidadeTotalGranel", label: "Capacidade Total de Granel (m³)" },
  // Texto livre de até 255 caracteres: aparece inteiro, quebrando linha (AC3).
  { key: "comentarios", label: "Comentários" },
  { key: "atualizacaoCapacidade", label: "Data Atualização Capacidade", format: formatDetailDate },
];
